<script setup lang="ts">
import { BtnTertiary } from '@shared/ui/buttons'

import { useButtonTaskCancel } from '../../model/creation/button-task-cancel.hook'

defineOptions({
  name: 'ButtonTaskCancel',
})

const { handleClick } = useButtonTaskCancel()
</script>

<template>
  <BtnTertiary
    text="Cancel"
    @click="handleClick"
  />
</template>
